var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"auth-layout"},[_c('v-main',{staticClass:"my-10 align-center"},[_c('v-container',[_c('v-row',[_c('v-col',{staticClass:"mx-auto",attrs:{"cols":"col","lg":"10","xl":"6"}},[_c('router-view')],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }